import React from "react";
import {
  Typography,
  TextField,
  Grid,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectEditCatalogData,
  selectIsEditMode,
  setCatalogDataField,
} from "@/features/connections/manageCatalogDataSlice";
import {
  defaultCode,
  blankCode,
} from "@/features/connections/integrationSlice";
import { AddEditCatalogPopup } from "./CatalogPopup";

const AddTaxGroupPopup = ({ onClose, onValidate, onComplete }) => {
  const dispatch = useDispatch();
  const dataValues = useSelector(selectEditCatalogData);
  const isEdit = useSelector(selectIsEditMode);

  const validateForm = () => {
    if (onValidate) {
      const result = onValidate(dataValues);
      if (!result.isValid) return result;
    }
    if (dataValues.TaxGroupCode === defaultCode) {
      return {
        isValid: false,
        message: `Tax Group Code cannot be saved as ${defaultCode}`,
      };
    }
    if (dataValues.TaxGroupCode === blankCode) {
      return {
        isValid: false,
        message: `Tax Group Code cannot be saved as ${blankCode}`,
      };
    }
    if (dataValues.TaxGroupCode?.includes(",")) {
      return {
        isValid: false,
        message: `The Tax Group Code cannot include a ','`,
      };
    }
    return { isValid: true };
  };

  const handleClose = () => {
    onClose();
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    dispatch(setCatalogDataField({ name, value }));
  };

  return (
    <AddEditCatalogPopup
      onClose={handleClose}
      onValidate={validateForm}
      onComplete={onComplete}
    >
      <Grid item xs={4} />
      <Grid item xs={4}>
        <Typography>Tax Group Code </Typography>
        <TextField
          disabled={isEdit}
          variant="outlined"
          name="TaxGroupCode"
          value={dataValues?.TaxGroupCode || ""}
          onChange={handleChange}
          sx={{
            width: 250,
            marginTop: 1,
            marginBottom: 2,
          }}
        />
      </Grid>

      <Grid item xs={4} />
    </AddEditCatalogPopup>
  );
};

export default AddTaxGroupPopup;
